// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"8e3c0fd4","787":"d396e546"}[chunkId] + ".chunk.js";
};